import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Visibility from "@material-ui/icons/Visibility";
import DateRangeIcon from '@material-ui/icons/DateRange';
import Edit from "@material-ui/icons/Edit";
// import Delete from "@material-ui/icons/Delete";
import { Menu } from "@material-ui/core";
import { Data as DataRow } from "./List/ListTable";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { EAnnounceStatus } from "../../../utils/enum";
import { VisibilityOff } from "@material-ui/icons";

export const ContextMenu = (props: {
    open: boolean;
    anchorEl: null | HTMLElement;
    handleClose: () => void;
    handleDeleteRow: (rowId: string) => void;
    handleAllowRow: (rowId: string) => void;
    row?: DataRow;
}) => {
    const history = useHistory();

    const handleShowPublicPreview = () => {
        if (props.row) {
            const win = window.open(
                `/details-announce-${props.row.id}`
                // "_blank"
            );
            win?.focus();
            props.handleClose();
        }
    };

    const handleEdit = () => {
        if (props.row) {
            history.push(`/announce/edit/${props.row.id}`);
            props.handleClose();
        }
    };

    const handleResumeEditRow = () => {
        if (props.row) {
            const { searchType, id } = props.row;
    
            switch (searchType) {
                case 'apts':
                    history.push(`/announce/add/${id}`);
                    break;
                case 'htls':
                    history.push(`/announceHotel/add/${id}`);
                    break;
                case 'cars':
                    history.push(`/announceCar/add/${id}`);
                    break;
                case 'rstt':
                    history.push(`/announceImmo/add/${id}`);
                    break;
                default:
                    //console.log("Unknown searchType");
                    break;
            }
    
            props.handleClose();
        }
    };
    

    const handleAllowRow = () => {
        if (props.row) {
            props.handleAllowRow(props.row.id);
            props.handleClose();
        }
    };
    const { t } = useTranslation();

    return (
        <Paper sx={{ width: 320, maxWidth: "100%" }}>
            <Menu
                id="cotenxt-menu-table"
                anchorEl={props.anchorEl}
                open={props.open}
                onClose={props.handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuList>
                    <MenuItem onClick={handleShowPublicPreview}>
                        <ListItemIcon>
                            <DateRangeIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>
                            {props.row?.searchType === "rstt" 
                                ? t("contextMenu.voirEnApercuPublic") 
                                : t("contextMenu.gererMonCalendrier")
                            }
                        </ListItemText>
                    </MenuItem>
                    {/* <Divider /> */}

                    {props.row?.state !== EAnnounceStatus.Published &&
                    props.row?.state !== EAnnounceStatus.Drafted ? (
                        <>
                            <Divider />
                            <MenuItem onClick={handleEdit}>
                                <ListItemIcon>
                                    <Edit fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>
                                    {t("contextMenu.editer")}
                                </ListItemText>
                            </MenuItem>
                        </>
                    ) : (
                        ""
                    )}

                    {/* <MenuItem onClick={handleDeleteRow}>
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("contextMenu.supprimer")}</ListItemText>
          </MenuItem> */}

                    {(props.row?.state === EAnnounceStatus.Published ||
                        props.row?.state ===
                            EAnnounceStatus.SuspendedByUser) && (
                        <>
                            <Divider />
                            <MenuItem onClick={handleAllowRow}>
                                <ListItemIcon>
                                    {props.row.state ===
                                    EAnnounceStatus.Published ? (
                                        <VisibilityOff fontSize="small" />
                                    ) : (
                                        <Visibility fontSize="small" />
                                    )}
                                </ListItemIcon>
                                <ListItemText>
                                    {props.row?.state ===
                                    EAnnounceStatus.Published
                                        ? t("contextMenu.desactiver")
                                        : t("contextMenu.activer")}
                                </ListItemText>
                            </MenuItem>
                        </>
                    )}

                    {props.row?.state === EAnnounceStatus.Drafted && (
                        <>
                            <Divider />
                            <MenuItem onClick={handleResumeEditRow}>
                                <ListItemIcon>
                                    <Edit fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>
                                    {t("contextMenu.continuer-l-edition")}
                                </ListItemText>
                            </MenuItem>
                        </>
                    )}
                </MenuList>
            </Menu>
        </Paper>
    );
};
